import React from 'react';
import './Input.scss';
import Input from './Input';

export default class InputTextArea extends React.Component {

  constructor(props) {
    super(props);

    this.id = Math.random().toString(36).substr(2);
  }

  handleChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  }

  render() {
    return (
        <Input {...this.props} className="ComponentInputTextArea">
          <div className="form-field">
            <textarea className="field-wrap"
                      value={this.props.value}
                      disabled={this.props.disabled}
                      defaultValue={this.props.defaultValue}
                      onChange={this.handleChange.bind(this)}
                      id={this.id}
                      style={this.props.styles}
            />
          </div>
        </Input>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InputTextArea.js